import { Prop } from '@typegoose/typegoose'
import { generateEntityId } from '../generateEntityId'

export class SubCompany {
  @Prop({ type: String, default: () => generateEntityId('subc') })
  _id: string

  @Prop({ type: String })
  name: string
}
